import {
  AppstoreOutlined,
  FileTextOutlined,
  FolderOutlined
} from "@ant-design/icons"
import { type ComponentType } from "react"

import { RoutesPaths } from "../../../../constants/routes.ts"
import { type TemplateAccent } from "./TemplateTypeCard.tsx"
import { type TemplateCountKey } from "./use-template-counts.ts"

export interface TemplateTypeDefinition {
  key: TemplateCountKey
  titleKey: string
  descriptionKey: string
  route: string
  Icon: ComponentType<{ className?: string }>
  accent: TemplateAccent
  chipKeys?: string[]
}

export const TEMPLATE_TYPES: TemplateTypeDefinition[] = [
  {
    key: "project",
    titleKey: "settingsTemplatesHub.cards.project.title",
    descriptionKey: "settingsTemplatesHub.cards.project.description",
    route: RoutesPaths.settings.projectTemplates,
    Icon: FolderOutlined,
    accent: "blue"
  },
  {
    key: "documents",
    titleKey: "settingsTemplatesHub.cards.documents.title",
    descriptionKey: "settingsTemplatesHub.cards.documents.description",
    route: RoutesPaths.settings.documentTemplates,
    Icon: FileTextOutlined,
    accent: "green",
    chipKeys: [
      "settingsTemplatesHub.cards.documents.chips.proposal",
      "settingsTemplatesHub.cards.documents.chips.contract"
    ]
  },
  {
    key: "dashboard",
    // Reuses the existing dashboard-templates title key so the two never drift.
    titleKey: "settingsDashboardTemplates.title",
    descriptionKey: "settingsTemplatesHub.cards.dashboard.description",
    route: RoutesPaths.settings.dashboardTemplates,
    Icon: AppstoreOutlined,
    accent: "purple"
  }
]
